import styled from 'styled-components'
import Accordion from '@mui/material/Accordion'

export const SummaryGrid = styled.div`
  background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft || theme.palette.colors.light};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
  border-radius: 8px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 18px;
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`

export const SummaryCard = styled.div`
  min-height: 92px;
  padding: 18px 18px 16px;
  position: relative;

  & + & {
    border-left: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
  }

  &::after {
    background: ${({ theme }) => theme.palette.sideMenu?.main || '#155DFC'};
    bottom: 0;
    content: '';
    height: 2px;
    left: 18px;
    opacity: .72;
    position: absolute;
    width: 34px;
  }

  @media (max-width: 900px) {
    &:nth-child(odd) {
      border-left: 0;
    }

    &:nth-child(n + 3) {
      border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
    }
  }

  @media (max-width: 520px) {
    & + & {
      border-left: 0;
      border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
    }
  }
`

export const SummaryLabel = styled.div`
  color: ${({ theme }) => theme.palette.colors.subdued || theme.palette.colors.muted};
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
`

export const SummaryValue = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 32px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  margin-top: 12px;
`

export const TableSurface = styled.div`
  overflow-x: auto;
  scrollbar-color: ${({ theme }) => theme.palette.sideMenu?.main || '#155DFC'} transparent;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.sideMenu?.main || '#155DFC'};
    border-radius: 999px;
  }

  .MuiPaper-root {
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.muted};
    min-width: 0;
    overflow: visible;
  }

  .MuiTable-root {
    border-collapse: separate;
    border-spacing: 0;
    min-width: 1280px;
    table-layout: fixed;
    width: 100%;
  }

  .MuiTableHead-root .MuiTableCell-root {
    background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong || theme.palette.colors.surface};
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
    color: ${({ theme }) => theme.palette.colors.subdued || theme.palette.colors.muted};
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0;
    padding: 14px 16px;
    text-transform: uppercase;
  }

  .MuiTableCell-root:nth-child(1) {
    width: 20%;
  }

  .MuiTableCell-root:nth-child(2) {
    width: 28%;
  }

  .MuiTableCell-root:nth-child(3) {
    width: 18%;
  }

  .MuiTableCell-root:nth-child(4) {
    width: 112px;
  }

  .MuiTableCell-root:nth-child(5) {
    width: 72px;
  }

  .MuiTableCell-root:nth-child(6) {
    width: 104px;
  }

  .MuiTableCell-root:nth-child(7) {
    width: 110px;
  }

  .MuiTableCell-root:nth-child(8) {
    width: 110px;
  }

  .MuiTableCell-root:nth-child(9) {
    background: ${({ theme }) => theme.palette.colors.surfaceElevatedSoft || theme.palette.colors.light};
    box-shadow: -12px 0 18px rgba(0, 0, 0, .14);
    position: sticky;
    right: 0;
    width: 148px;
    z-index: 2;
  }

  .MuiTableHead-root .MuiTableCell-root:nth-child(9) {
    background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong || theme.palette.colors.surface};
    z-index: 3;
  }

  .MuiTableBody-root .MuiTableRow-root {
    background: transparent;
    transition: background .18s ease;
  }

  .MuiTableBody-root .MuiTableRow-root:hover {
    background: ${({ theme }) => theme.palette.colors.buttonGhost || 'rgba(255, 255, 255, .06)'};
  }

  .MuiTableBody-root .MuiTableCell-root {
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
    color: ${({ theme }) => theme.palette.colors.muted};
    font-size: 13px;
    font-weight: 500;
    height: 64px;
    padding: 14px 16px;
  }

  .MuiTableBody-root .MuiTableCell-root:first-child {
    color: ${({ theme }) => theme.palette.colors.text};
    font-weight: 800;
  }
`

export const StatusPill = styled.span`
  align-items: center;
  background: ${({ active, theme }) => active ? 'rgba(32, 211, 86, .12)' : theme.palette.colors.buttonGhost};
  border: 1px solid ${({ active }) => active ? 'rgba(32, 211, 86, .34)' : 'rgba(153, 161, 175, .24)'};
  border-radius: 999px;
  color: ${({ active }) => active ? '#67E08D' : '#B4BBC7'};
  display: inline-flex;
  font-size: 11px;
  font-weight: 800;
  justify-content: center;
  min-width: 76px;
  padding: 6px 10px;
`

export const LinkText = styled.div`
  color: ${({ theme }) => theme.palette.sideMenu?.main || '#155DFC'};
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const TitleText = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ActionRow = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  min-width: 124px;
`

export const IconButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.buttonGhost || 'rgba(255, 255, 255, .08)'};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || 'rgba(255, 255, 255, .12)'};
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.colors.text};
  cursor: pointer;
  display: inline-flex;
  height: 36px;
  justify-content: center;
  transition: background .16s ease, border-color .16s ease, transform .16s ease;
  width: 36px;

  &:hover {
    background: ${({ theme }) => theme.palette.colors.badgeMuted || 'rgba(21, 93, 252, .16)'};
    border-color: rgba(21, 93, 252, .38);
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: .45;
    transform: none;
  }
`

export const EmptyState = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.palette.colors.muted};
  display: flex;
  flex-direction: column;
  min-height: ${({ compact }) => compact ? '160px' : '260px'};
  justify-content: center;
  padding: ${({ compact }) => compact ? '28px 20px' : '44px 20px 52px'};
  text-align: center;
`

export const EmptyGraphic = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.palette.colors.badgeMuted || 'rgba(21, 93, 252, .16)'};
  border: 1px solid rgba(21, 93, 252, .28);
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.sideMenu?.main || '#155DFC'};
  display: flex;
  font-size: 30px;
  font-weight: 300;
  height: 56px;
  justify-content: center;
  line-height: 1;
  margin-bottom: 18px;
  width: 56px;
`

export const EmptyTitle = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 6px;
`

export const EmptyAction = styled.div`
  margin-top: 20px;
`

export const ModalBody = styled.div`
  display: grid;
  gap: 24px;
`

export const FormFieldsGrid = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const FormField = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FormWideField = styled(FormField)`
  grid-column: 1 / -1;
`

export const CompanyHint = styled.div`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 12px;
  font-weight: 700;
`

export const FormActions = styled.div`
  background: ${({ theme }) => theme.palette.colors.backgroundStrong};
  border-top: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
  bottom: -32px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin: 0 -32px;
  padding: 18px 32px;
  position: sticky;
  z-index: 3;

  @media (max-width: 1000px) {
    bottom: -24px;
    margin: 0 -24px;
    padding: 16px 24px;
  }

  @media (max-width: 480px) {
    bottom: -18px;
    margin: 0 -18px;
    padding: 14px 18px;
  }
`

export const HistoryList = styled.div`
  display: grid;
  gap: 10px;
`

export const HistoryItem = styled.div`
  background: ${({ theme }) => theme.palette.colors.buttonGhost || 'rgba(255, 255, 255, .06)'};
  border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft || theme.palette.colors.borderStrong};
  border-radius: 8px;
  padding: 14px;
`

export const HistoryName = styled.div`
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 14px;
  font-weight: 800;
`

export const HistoryMeta = styled.div`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 13px;
  line-height: 1.5;
  margin-top: 4px;
`

export const AdvancedOptions = styled(Accordion)`
  && {
    color: ${({ theme }) => theme.palette.colors.text};
    background: ${({ theme }) => theme.palette.colors.surfaceElevated};
    border: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    box-shadow: none;
  }
  & .MuiAccordionSummary-expandIconWrapper {
    color: ${({ theme }) => theme.palette.colors.text};
  }
`
